import type { FC } from 'react';

import Skeleton from 'Storybook/core/Skeleton/Skeleton';
import { EN_DASH } from 'Utilities/consts';

import { getPaginationRange } from '../Pagination.helpers';
import type { PaginationMeta } from '../Pagination.types';

import styles from '../Pagination.module.scss';

type PaginationButtonProps = {
	isEmptyState: boolean;
	isLoading: boolean;
	paginationMeta: PaginationMeta;
};

export const PaginationText: FC<PaginationButtonProps> = ({ isEmptyState, isLoading, paginationMeta }) => {
	if (isLoading) {
		return (
			<span className={styles.text}>
				<Skeleton width={15} />
			</span>
		);
	}

	if (isEmptyState) {
		return (
			<span className={styles.text}>
				<span aria-current="page" className={styles.range}>
					0 {EN_DASH} 0
				</span>{' '}
				of 0
			</span>
		);
	}

	return (
		<span className={styles.text}>
			<span aria-current="page" className={styles.range}>
				{getPaginationRange(paginationMeta)}
			</span>
			of {paginationMeta.totalRecords}
		</span>
	);
};
